<!-- eslint-disable vue/no-v-html -->
<template>
  <i
    class="sam-icon"
    :class="{ 'is-loading': loading }"
    :style="cssStyle"
    data-samora
    v-bind="$attrs"
    v-on="$listeners"
    v-html="require(`../../../icons/${icon}${filled ? '--filled' : ''}.svg`)"
  />
</template>

<script>
import SAMORA_SIZES from '../../../utils/constants/samora-sizes.enum';

export const ICON_SIZES = {
  X_SMALL: SAMORA_SIZES.X_SMALL,
  SMALL: SAMORA_SIZES.SMALL,
  MEDIUM: SAMORA_SIZES.MEDIUM,
  LARGE: SAMORA_SIZES.LARGE,
};

export const iconSizesToPxMapper = new Map([
  [ICON_SIZES.X_SMALL, 16],
  [ICON_SIZES.SMALL, 20],
  [ICON_SIZES.MEDIUM, 24],
  [ICON_SIZES.LARGE, 32],
]);

export default {
  name: 'SamIcon',
  props: {
    /**
     * The SamIcon name that should be displayed
     */
    icon: {
      type: String,
      required: true,
      default: 'interface-notification',
    },
    /**
     * The icon size. It can be any of the following: xs, sm, md, lg or any Integer number.
     * @values xs, sm, md, lg
     */
    size: {
      type: [String, Number],
      required: false,
      default: SAMORA_SIZES.MEDIUM,
      // eslint-disable-next-line max-len
      validator: (val) =>
        Number.isInteger(val) || Array.from(iconSizesToPxMapper.keys()).includes(val),
    },
    /**
     * The icon color. It defaults for the text current color
     */
    color: {
      type: String,
      required: false,
      default: 'currentColor',
    },
    /**
     * There are filled versions for icons
     * To use them, set this prop to true
     * Please check the icon list to see which icons have filled versions
     */
    filled: {
      type: Boolean,
      required: false,
      default: false,
    },
    /** If the icon is loading
     * @values true, false
     */
    loading: {
      type: Boolean,
      required: false,
      default: false,
    },
  },
  computed: {
    cssStyle() {
      let iconSize;
      if (Number.isInteger(this.size)) {
        iconSize = this.size;
      } else {
        iconSize = iconSizesToPxMapper.get(this.size);
      }
      return {
        '--icon-size': `${iconSize}px`,
        '--icon-color': this.color,
      };
    },
  },
};
</script>

<style lang="scss" scoped>
.sam-icon {
  display: inline-block;
  line-height: 0; // fit icon vertically
  color: var(--icon-color); // from computed property cssStyle

  &.is-loading {
    @include color-blink;
  }

  :deep(svg) {
    width: var(--icon-size); // from computed property cssStyle
    height: var(--icon-size); // from computed property cssStyle
  }
}
</style>
